import React, { useMemo } from 'react';
import Lottie from 'lottie-react';
import './WhyUsSection.css';
import onlineLearningAnimation from '../assets/animations/online-learning.json';
import businessmanRocketAnimation from '../assets/animations/businessman-rocket.json';
import teacherMathAnimation from '../assets/animations/teacher-math.json';
import processAnimation from '../assets/animations/process.json';

// Style dla Lottie - poza komponentem, żeby uniknąć tworzenia nowych obiektów przy każdym renderze
const LOTTIE_STYLES = {
  large: { width: '120px', height: '120px' },
  medium: { width: '100px', height: '100px' }
} as const;

const WhyUsSection: React.FC = () => {
  const benefits = useMemo(() => [
    {
      animation: businessmanRocketAnimation,
      title: "Motywacja i zaangażowanie",
      description: "Masz problemy z motywacją do nauki? A może nie masz na nią planu? Nasi tutorzy pomogą dostosować naukę tak, żeby była skuteczna i przyjemna.",
      stat: "96%",
      statLabel: "uczniów poprawia oceny",
      size: "large"
    },
    {
      animation: teacherMathAnimation,
      title: "Doświadczeni tutorzy",
      description: "Pasjonaci, którzy potrafią wytłumaczyć najtrudniejsze zagadnienia w prosty sposób. To trochę tak, jakby Twój najlepszy przyjaciel był nauczycielem matematyki.",
      stat: "5+",
      statLabel: "lat doświadczenia",
      size: "medium"
    },
    {
      animation: onlineLearningAnimation,
      title: "Nowoczesne metody",
      description: "Tablice interaktywne przykłady z życia czy starannie dobierane materiały oraz notatki do których możesz wrócić w każdej chwili.",
      stat: "100%",
      statLabel: "online",
      size: "medium"
    },
    {
      animation: processAnimation,
      title: "Sprawdzona metodologia",
      description: "Regularne testy, monitoring postępów i indywidualny plan rozwoju.",
      stat: "1:1",
      statLabel: "podejście",
      size: "large"
    }
  ], []);

  return (
    <section id="why-us" className="why-us-section">
      <div className="why-us-container">
        <div className="section-header">
          <span className="section-badge">Dlaczego my?</span>
          <h2>Twój sukces to nasz cel</h2>
          <p>Sprawdzone metody, które działają od lat</p>
        </div>

        <div className="bento-grid">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className={`bento-card bento-card-${benefit.size} bento-card-${index + 1}`}
            >
              <div className="bento-card-inner">
                <div className="bento-animation">
                  <Lottie
                    animationData={benefit.animation}
                    loop={true}
                    autoplay={true}
                    style={LOTTIE_STYLES[benefit.size as keyof typeof LOTTIE_STYLES]}
                  />
                </div>
                <div className="bento-content">
                  <h3 className="bento-title">{benefit.title}</h3>
                  <p className="bento-description">{benefit.description}</p>
                </div>
                <div className="bento-stat">
                  <span className="stat-value">{benefit.stat}</span>
                  <span className="stat-label">{benefit.statLabel}</span>
                </div>
              </div>
              <div className="bento-glow"></div>
            </div>
          ))}
          {/* Karta ze zdjęciem studenta */}
          <div className="bento-card bento-card-image bento-card-5">
            <img
              src="/images/student-success-nobg.png"
              alt="Zadowolony student z materiałami do nauki"
              className="bento-student-image"
              loading="eager"
            />
          </div>
        </div>

        <div className="why-us-cta">
          <button
            className="why-us-cta-button"
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
          >
            Rozpocznij naukę
          </button>
        </div>
      </div>
    </section>
  );
};

export default WhyUsSection;
